import { BaseError } from "../BaseError";

export const VERSION = {
  "1st style": 0,
  substream: 1,
  "2nd style": 2,
  "3rd style": 3,
  "4th style": 4,
  "5th style": 5,
  "6th style": 6,
  "7th style": 7,
  "8th style": 8,
  "9th style": 9,
  "10th style": 10,
  IIDX_RED: 11,
  HAPPY_SKY: 12,
  DistorteD: 13,
  GOLD: 14,
  DJ_TROOPERS: 15,
  EMPRESS: 16,
  SIRIUS: 17,
  Resort_Anthem: 18,
  Lincle: 19,
  tricoro: 20,
  SPADA: 21,
  PENDUAL: 22,
  copula: 23,
  SINOBUZ: 24,
  CANNON_BALLERS: 25,
  Rootage: 26,
  HEROIC_VERSE: 27,
  BISTROVER: 28,
  CastHour: 29,
  RESIDENT: 30,
  EPOLIS: 31,
  Pinky_Crush: 32,
  Sparkle_Shower: 33,
  ZINRAI: 34,
} as const;

export type Version = (typeof VERSION)[keyof typeof VERSION];

export const VERSION_STRING = {
  0: "1st style",
  1: "substream",
  2: "2nd style",
  3: "3rd style",
  4: "4th style",
  5: "5th style",
  6: "6th style",
  7: "7th style",
  8: "8th style",
  9: "9th style",
  10: "10th style",
  11: "IIDX RED",
  12: "HAPPY SKY",
  13: "DistorteD",
  14: "GOLD",
  15: "DJ TROOPERS",
  16: "EMPRESS",
  17: "SIRIUS",
  18: "Resort Anthem",
  19: "Lincle",
  20: "tricoro",
  21: "SPADA",
  22: "PENDUAL",
  23: "copula",
  24: "SINOBUZ",
  25: "CANNON BALLERS",
  26: "Rootage",
  27: "HEROIC VERSE",
  28: "BISTROVER",
  29: "CastHour",
  30: "RESIDENT",
  31: "EPOLIS",
  32: "Pinky Crush",
  33: "Sparkle Shower",
  34: "ZINRAI",
} as const;

export const LATEST_VERSION: Version = Object.values(VERSION).reduce((prev, e) => (prev > e ? prev : e));

export const isVersion = (n: unknown): n is Version => {
  return typeof n === "number" && Object.values<typeof n>(VERSION).includes(n);
};

export const parseVersion = (str: string): Version => {
  const result = Object.values(VERSION).find((key) => VERSION_STRING[key] === str);
  if (result === undefined) {
    throw new ParseVersionError("Versionに変換できません");
  }
  return result;
};

export class ParseVersionError extends BaseError {}
